import React, { useState, useEffect, useContext } from 'react';
import AppContext from "../../../Store/AppContext";
import { ObterUrlMidia } from '../../../Services/WhatsApp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArchive } from '@fortawesome/free-solid-svg-icons';

const MensagemDocumento = ({ mensagem }) => {
    const { contaWhatsAppDefault } = useContext(AppContext);
    const mediaId = mensagem.logConversasWhatsAppMediaId;
    const initialUrl = mensagem._mediaUrl;
    const nomeArquivo = mensagem.logConversasWhatsAppMensagem || 'Documento';

    const [url, setUrl] = useState(initialUrl || null);
    const [loading, setLoading] = useState(!initialUrl);

    useEffect(() => {
        if (initialUrl || !mediaId) return;
        setLoading(true);
        ObterUrlMidia(contaWhatsAppDefault, mediaId).then(({ success, url }) => {
            if (success && url) setUrl(url);
            setLoading(false);
        });
    }, [mediaId]);

    if (loading) return <div>[Carregando documento...]</div>;
    if (!url) return <div>[Documento não disponível]</div>;

    return (
        <div className="documento-wrapper">
            <span className="documento-icone"><FontAwesomeIcon icon={faFileArchive} /></span>
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="documento-link"
            >
                Baixar Arquivo
            </a>
        </div>
    );
};

export default MensagemDocumento;
